import React from 'react';

// The published Base44 URL is the build that's already wrapped as the native
// app on both stores — download buttons there would be circular, so they only
// appear on the custom domain.
export const isCustomDomain = () => {
  // /Home is the Website homepage — always render it as the custom-domain
  // experience so it can be previewed exactly as website visitors see it.
  if (window.location.pathname.toLowerCase() === '/home') return true;
  const host = window.location.hostname;
  return !host.endsWith('base44.app') && !host.endsWith('localhost') && !host.startsWith('127.');
};

const AppleIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 shrink-0">
    <path d="M17.05 12.54c.02-2.2 1.79-3.26 1.87-3.31-1.02-1.5-2.61-1.71-3.17-1.73-1.35-.14-2.63.79-3.31.79-.69 0-1.74-.77-2.86-.75-1.47.02-2.83.86-3.58 2.17-1.53 2.66-.39 6.59 1.1 8.75.73 1.05 1.6 2.23 2.74 2.19 1.1-.04 1.52-.71 2.85-.71 1.33 0 1.7.71 2.86.69 1.18-.02 1.94-1.08 2.66-2.14.83-1.21 1.18-2.39 1.2-2.45-.03-.01-2.3-.88-2.36-3.5zM14.9 5.86c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.64-1.04 1.68-.91 2.67.97.08 1.96-.49 2.55-1.22z" />
  </svg>
);

const GooglePlayIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24" className="w-6 h-6 shrink-0">
    <path fill="#EA4335" d="M3.6 2.3 13.8 12 3.6 21.7c-.37-.28-.6-.75-.6-1.34V3.64c0-.59.23-1.06.6-1.34z" />
    <path fill="#FBBC04" d="M17.3 8.5 13.8 12 3.6 2.3c.36-.28.9-.32 1.5.01L17.3 8.5z" />
    <path fill="#34A853" d="M17.3 15.5 5.1 21.69c-.6.33-1.14.29-1.5.01L13.8 12l3.5 3.5z" />
    <path fill="#4285F4" d="M20.9 10.7c.8.44.8 2.16 0 2.6l-3.6 2.2-3.5-3.5 3.5-3.5 3.6 2.2z" />
  </svg>
);

export default function AppStoreBadges({ appStoreUrl, playStoreUrl, className = '' }) {
  if (!appStoreUrl && !playStoreUrl) return null;
  if (!isCustomDomain()) return null;

  const badge = 'flex items-center justify-center gap-3 w-full px-4 py-3 rounded-xl bg-brand-navy text-white hover:opacity-90 transition-opacity md:w-auto md:justify-start md:py-2.5';

  return (
    <div className={className}>
      <p className="text-xs font-semibold tracking-wide text-brand-gray uppercase mb-3">Download our app</p>
      <div className="grid grid-cols-2 gap-3 md:flex md:flex-wrap">
        {appStoreUrl && (
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className={badge} aria-label="Download on the App Store">
            <AppleIcon />
            <span className="leading-tight text-left">
              <span className="block text-[10px] opacity-80">Download on the</span>
              <span className="block text-sm font-semibold">App Store</span>
            </span>
          </a>
        )}
        {playStoreUrl && (
          <a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className={badge} aria-label="Get it on Google Play">
            <GooglePlayIcon />
            <span className="leading-tight text-left">
              <span className="block text-[10px] opacity-80">Get it on</span>
              <span className="block text-sm font-semibold">Google Play</span>
            </span>
          </a>
        )}
      </div>
    </div>
  );
}